<mat-card>
    <mat-card-header>
        <mat-card-title>Cadastrar Cidade</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>
        <form [formGroup]="cepForm">
            <div class="row">
                <div class="col-auto">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Cep</mat-label>
                        <input type="text" matInput formControlName="cep" required (ngModelChange)="buscarCEP()"
                            [textMask]="{mask: maskCEP, guide:false}" autofocus>
                        <mat-hint align="end">Informe um cep válido de qualquer endereço da cidade que deseja adicionar
                            ao sistema</mat-hint>
                        <mat-error *ngIf="f.cep.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row mt-4" *ngIf="bCidade">
                <mat-divider></mat-divider>
            </div>

            <div class="row mt-2" *ngIf="bCidade">
                <div class="col-auto">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Cidade</mat-label>
                        <input type="text" matInput formControlName="cidade" required>
                    </mat-form-field>
                </div>

                <div class="col-1">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>UF</mat-label>
                        <input type="text" matInput formControlName="uf" required>
                    </mat-form-field>
                </div>

                <div class="col-auto">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Latitude</mat-label>
                        <input type="text" matInput formControlName="latitude" required>
                    </mat-form-field>
                </div>

                <div class="col-auto">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Longitude</mat-label>
                        <input type="text" matInput formControlName="longitude" required>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </mat-card-content>

    <mat-divider></mat-divider>

    <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
        <button mat-flat-button color="warn" (click)="limparCampos()">
            <mat-icon>clear</mat-icon> Limpar Campos
        </button>
        <button *ngIf="bCidade" mat-flat-button color="primary" (click)="cadastrar()">
            <mat-icon>check</mat-icon> Cadastrar
        </button>
    </section>
</mat-card>